export const BOOKING_LOCATION_OPTIONS = [
  {
    id: 'to-be-qualified',
    value: 'to-be-qualified',
    label: 'To be qualified',
    selected: true,
  },
  {
    id: 'qualified',
    value: 'qualified',
    label: 'Qualified',
    selected: true,
  },
  {
    id: 'unqualified',
    value: 'unqualified',
    label: 'Unqualified',
    selected: true,
  },
  {
    id: 'dont-need-to-be-qualified',
    value: 'dont-need-to-be-qualified',
    label: "Don't need to be qualified yet",
    selected: true,
  },
];

export const LOCATION_OPTIONS = [
  {
    id: 'to-be-qualified',
    value: 'to-be-qualified',
    label: 'To be qualified',
    selected: true,
  },
  {
    id: 'qualified',
    value: 'qualified',
    label: 'Qualified',
    selected: true,
  },
  {
    id: 'unqualified',
    value: 'unqualified',
    label: 'Unqualified',
    selected: true,
  },
  {
    id: 'dont-need-to-be-qualified',
    value: 'dont-need-to-be-qualified',
    label: "Don't need to be qualified yet",
    selected: true,
  },
];

export const GENDER_OPTIONS = [
  {
    id: 'Homme',
    title: 'Male',
  },
  {
    id: 'Femme',
    title: 'Female',
  },
];

export const FIRST_TELE_LOCATION_OPTIONS = [
  {
    id: 'to-be-qualified',
    value: 'to-be-qualified',
    label: 'To be qualified',
  },
  {
    id: 'qualified',
    value: 'qualified',
    label: 'Qualified',
    selected: true,
  },
  {
    id: 'unqualified',
    value: 'unqualified',
    label: 'Unqualified',
  },
];

export const PROCESS_STAGES = [
  {
    value: 'Booking Request',
    label: 'Booking Request',
  },
  {
    value: '1st Teleconsultation',
    label: '1st Teleconsultation',
  },
  {
    value: 'Polygraphy',
    label: 'Polygraphy',
  },
  {
    value: '2nd Teleconsultation',
    label: '2nd Teleconsultation',
  },
  {
    value: 'Treatment',
    label: 'Treatment',
  },
];

export const BIRTH_RANK = [
  {
    value: 0,
    label: 'Pas de jumeau ou premier jumeau ou premier triplet',
  },
  {
    value: 1,
    label: 'Deuxième jumeau ou deuxième triplet',
  },
  {
    value: 2,
    label: 'Troisième triplet',
  },
  {
    value: 3,
    label: '4eme enfant',
  },
  {
    value: 4,
    label: '5eme enfant',
  },
  {
    value: 5,
    label: '6eme enfant',
  },
  {
    value: 6,
    label: '7eme enfant',
  },
  {
    value: 7,
    label: '8eme enfant',
  },
  {
    value: 8,
    label: '9eme enfant',
  },
];

export const REGIME = [
  {
    value: '01',
    label: '01 - Régime Général',
  },
  {
    value: '02',
    label: '02 - MSA (Régime Agricole)',
  },
  {
    value: '03',
    label: '03 - RSI (Régime Sociale des Indépendants)',
  },
  {
    value: '04',
    label:
      '04 - CPRPSNCF (Caisse de Prévoyance et de Retraite du Personnel de la SNCF)',
  },
  {
    value: '05',
    label:
      '05 - CCAS RATP (Caisse de Coordination des Assurances Sociales de la RATP)',
  },
  {
    value: '06',
    label: '06 - ENIM (Établissement National des Invalides de la Marine)',
  },
  {
    value: '07',
    label:
      '07 - CANSSM (Caisse Autonome Nationale de la Sécurité Sociale des Mines)',
  },
  {
    value: '08',
    label: '08 - CNMSS',
  },
  {
    value: '10',
    label:
      '10 - CRPCEN (Caisse de Retraite et de Prévoyance des Clercs et Employés de Notaire)',
  },
  {
    value: '14',
    label: "14 - Régime de l'Assemblée Nationale",
  },
  {
    value: '15',
    label: '15 - Régime du Sénat',
  },
  {
    value: '16',
    label: '16 - Régime du Port Autonome de Bordeaux',
  },
  {
    value: '17',
    label: "17 - CFE (Caisse des Français à l'Étranger)",
  },
  {
    value: '80',
    label: '80 - Ministère des anciens combattants',
  },
  {
    value: '90',
    label:
      "90 - CAVIMAC (Caisse d'Assurance Vieillesse, Invalidité et Maladie des Cultes)",
  },
  {
    value: '91',
    label: "91 - MGEN (Mutuelle Générale de l'Éducation Nationale)",
  },
  {
    value: '92',
    label: '92 - LMG (La Mutuelle Générale)',
  },
  {
    value: '93',
    label: '93 - MGP (Mutuelle Générale de la Police)',
  },
  {
    value: '94',
    label: '94 - MFPS-SOLSANTIS',
  },
  {
    value: '95',
    label: '95 - MNH (Mutuelle Nationale des Hospitaliers)',
  },
  {
    value: '96',
    label: '96 - HFP (Harmonie Fonction Publique)',
  },
  {
    value: '99',
    label:
      '99 - INTERIALE (Mutuelle de la Police et de Préfectures), CAMIEG (Caisse d’Assurance Maladie des Industries Électriques et Gazières), MCVPAP (Ville de Paris et Assistance Publique), MAEE (Mutuelle des Affaires Etrangères et Européennes), MAGE Lyon et Paris',
  },
];

export const CUSTOMER_COLUMNS = [
  {
    label: 'Customer',
    accessor: 'customer',
    type: 'customerDirect',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Berlin questionnaire score',
    accessor: 'score',
    type: 'text',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'Location',
    accessor: 'location',
    type: 'select',
    isFilterable: true,
    options: LOCATION_OPTIONS,
    classNames: 'th-list-cellwidth-240',
  },
];

export const PATIENT_COLUMNS = [
  {
    label: 'Full name',
    accessor: 'customer',
    type: 'customerName',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Contact details',
    accessor: 'customer',
    type: 'customerContact',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Date of birth',
    accessor: 'dateOfBirth',
    type: 'dateOfBirth',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'City',
    accessor: 'city',
    type: 'text',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
];

export const NON_SLEEP_PATIENT_COLUMNS = [
  {
    label: 'Full name',
    accessor: 'customer',
    type: 'customerName',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'Contact details',
    accessor: 'customer',
    type: 'customerContact',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    selected: true,
  },
];

export const PATIENT_RIGHTS_OPTIONS = [
  {
    id: 'blank',
    value: null,
    label: 'Blank',
    selected: true,
  },
  {
    id: 'required-to-pay-for-consultations-and-examinations',
    value: 'required-to-pay-for-consultations-and-examinations',
    label: 'Required to pay for consultations and examinations',
    selected: true,
  },
  {
    id: 'required-to-pay-for-consultations-only',
    value: 'required-to-pay-for-consultations-only',
    label: 'Required to pay for consultations only',
    selected: true,
  },
  {
    id: 'not-required-to-pay-for-consultations-and-examinations',
    value: 'not-required-to-pay-for-consultations-and-examinations',
    label: 'Not required to pay for consultations and examinations',
    selected: true,
  },
];

export const SCHEDULE_DROPDOWN_OPTIONS = ({
  id,
  name,
  lastName,
  email,
  phone,
  utm_source,
  utm_medium,
}) => {
  const params = {
    name,
    last_name: lastName,
    email,
    phone_number: phone,
    utm_source,
    utm_medium,
  };
  const filteredParams = Object.keys(params)
    .filter((key) => params[key] != null)
    .reduce((obj, key) => {
      obj[key] = params[key];
      return obj;
    }, {}); // remove null keys

  const searchParams = new URLSearchParams(filteredParams);
  const queryString = searchParams.toString();

  return [
    {
      id: 'schedule-nurse-tc',
      label: 'Schedule nurse teleconsultation',
      url:
        process.env.REACT_APP_API_URL === 'https://api.sleepdoctor.me'
          ? `https://calendly.com/sleepdoctor-calendar/teleconsultation?${queryString}`
          : `https://calendly.com/test-website/round-robin-test-event-for-website?${queryString}`,
    },
    {
      id: 'schedule-doctor-tc',
      label: 'Schedule doctor teleconsultation',
      url:
        process.env.REACT_APP_API_URL === 'https://api.sleepdoctor.me'
          ? `https://calendly.com/sleepdoctors?${queryString}`
          : `https://calendly.com/sddev?${queryString}`,
    },
    {
      id: 'schedule-polygraphy',
      label: 'Schedule polygraphy',
      url: `/polygraphies/add?customerId=${id}`,
    },
    {
      id: 'schedule-polysomnography',
      label: 'Schedule polysomnography',
      url: `/polysomnographies/add?customerId=${id}`,
    },
  ];
};
